import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdSubscriptionsCount = z.any()
export type TagsGetMunicipalities_municipalityIdSubscriptionsCount = z.infer<typeof tagsGetMunicipalities_municipalityIdSubscriptionsCount>

export const paramsGetMunicipalities_municipalityIdSubscriptionsCount = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdSubscriptionsCount = z.infer<typeof paramsGetMunicipalities_municipalityIdSubscriptionsCount>

export const responseGetMunicipalities_municipalityIdSubscriptionsCount = z.object({ "payload": z.object({ "count": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdSubscriptionsCount = z.infer<typeof responseGetMunicipalities_municipalityIdSubscriptionsCount>

interface IGetMunicipalities_municipalityIdSubscriptionsCount extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdSubscriptionsCount,
  params: ParamsGetMunicipalities_municipalityIdSubscriptionsCount,
  response: ResponseGetMunicipalities_municipalityIdSubscriptionsCount
}
export const URL = '/municipalities/:municipalityId/subscriptions/count'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdSubscriptionsCount,
    params: paramsGetMunicipalities_municipalityIdSubscriptionsCount,
    response: responseGetMunicipalities_municipalityIdSubscriptionsCount
  }
}
export interface Municipalities_municipalityIdSubscriptionsCount extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdSubscriptionsCount
}